import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { FormsModule, NgForm } from '@angular/forms';
import { SimpleButtonComponent } from '../../../../buttons/simple-medium-button/simple-button.component';
import { PCOLineItemGroup } from '@app/store/prime-commitments/prime-commitments.types';
import { getEmptyPotentialChangeLineItem } from '@app/store/prime-commitments/prime-commitments.constants';
import { PcoNewScopeEntryComponent } from '@app/framework/interaction-bar/prime-commitments/change-actions/change-action-pco-sidebar/pco-new-scope-entry/pco-new-scope-entry.component';
import { SidebarHeaderComponent } from '@app/framework/interaction-bar/sidebar-header/sidebar-header.component';

@Component({
  selector: 'app-change-action-pco-sidebar',
  imports: [
    SimpleButtonComponent,
    NgScrollbar,
    FormsModule,
    PcoNewScopeEntryComponent,
    SidebarHeaderComponent,
  ],
  templateUrl: './change-action-pco-sidebar.component.html',
  styleUrl: './change-action-pco-sidebar.component.scss',
})
export class ChangeActionPCOSidebarComponent {
  @ViewChild('lineItemsForm') form: NgForm;

  @Input() lineItemGroups: PCOLineItemGroup[] = [];
  // @Input({ required: true }) name: string;
  @Output() lineItemGroupsChange = new EventEmitter<PCOLineItemGroup[]>();
  @Output() back = new EventEmitter<void>();
  @Output() saveForm = new EventEmitter<void>();

  addEntry() {
    this.lineItemGroups.push({
      ...getEmptyPotentialChangeLineItem(),
    });
    this.lineItemGroupsChange.emit(this.lineItemGroups);
  }

  goBack() {
    this.back.emit();
  }

  submitForm() {
    this.form.form.markAllAsTouched();
    if (this.form.form.invalid) {
      return;
    }
    this.saveForm.emit();
  }

  deleteLineItem(index: number) {
    this.lineItemGroups.splice(index, 1);
  }

  lineItemUpdated($event: PCOLineItemGroup, index: number) {
    this.lineItemGroups[index] = $event;
    this.lineItemGroupsChange.emit(this.lineItemGroups);
  }
}
